type RGBString = `rgb(${string})`

export const rgbToRgba = (color: RGBString, alpha: number) => {
  const rgb = color
    .replace("rgb(", "") // Isolate the RGB values => "2, 107, 84)"
    .slice(0, -1) // Remove the closing parathesis => "2, 107, 84"

  return `rgba(${rgb}, ${alpha})`
}
